import { checkoutShippingFulfillmentMethodStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingFulfillmentMethodSelector";
import { RadioStyle } from "@insite/mobius/Radio";
import { COLORS } from "@store/theme/common/design";
import { checkoutBlockTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(checkoutShippingFulfillmentMethodStyles, {
    container: {
        css: css`
            padding-top: 10px;
            padding-bottom: 40px;
            border-bottom: 1px solid ${COLORS.border.base};
            margin-bottom: 15px;
        `,
    },
    headingText: {
        variant: "h3",
        css: css`
            ${checkoutBlockTitleStyles()}
        `,
    },
    radioGroup: {
        css: css`
            display: block;
            ${RadioStyle} {
                display: inline-block;
                margin-right: 5em;
                & + ${RadioStyle} {
                    margin-top: 0;
                }
            }
        `,
    },
});
